import React from "react";
import "./Cards.css";

function PlanCard({ plan, isSelected, onSelect }) {
  console.log({ isSelected: isSelected });
  return (
    <div
      className={` plans-grid ${isSelected ? "selected" : ""}`}
      onClick={onSelect}
    >
      <div className="card payment-card ">
        <div className="card-body">
          <div className="plan-header ">
            <div>
              <h2 className="card-title">{plan.name}</h2>
              <p className="card-text">{plan.description}</p>
            </div>
            <div className="mb-5">
              <input
                type="checkbox"
                id={`payment-checkbox-${plan.id}`}
                checked={isSelected}
                onChange={onSelect}
              />
            </div>
          </div>
          <hr />
          <h5 className="bold">
            Price: <span className="span-price">{plan.price}/{plan.get_duration_display}</span>
          </h5>
          
          <h5 className="bold">Key Features:</h5>
          <ul>
            {/* {plan.features.map((feature, index) => (
              <li key={index}>{feature}</li>
            ))} */}
          </ul>
        </div>
      </div>
    </div>
  );
}

export default PlanCard;
